<script setup>
import {
  computed,
  ref,
  useHead,
  useImageSource,
  useRoute,
  useSanityQuery,
} from '#imports';
import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import { getQuery as getSpecialQuery } from '~/groq-queries/z-rating';

const route = useRoute();

const title = 'Z-рейтинг';
const description =
  'Рейтинг российских научных деятелей по их поддержке войны в Украине';

const contentQuery = getSpecialQuery();
const { data: content, refresh } = await useSanityQuery(contentQuery);

const ogImageUrl = computed(() =>
  useImageSource({
    image: content.value.ogImage,
  })
);

useHead({
  title,
  meta: getCommonMetaTags({
    path: route.fullPath,
    ogType: 'website',
    title,
    description,
    ogImageUrl: ogImageUrl.value,
  }),
});

const { previewId } = route.query;
const isDataEmpty = computed(() => !content.value?._id);
const isPreview = computed(() => !isDataEmpty.value && previewId);

const bottomOffset = ref(0);
const forceHideBottomOffset = ref(0);
</script>

<template>
  <LayoutDefaultPage is-header-shown is-hide-footer is-transparent-header>
    <template #header-card>
      <div class="special__header-card">
        <ArticleHeaderCard :article="content" />
      </div>
    </template>
    <template v-if="isPreview" #progress-bar>
      <PreviewBar @click="refresh" />
    </template>

    <div class="special">
      <div v-if="bottomOffset > 0" class="special__progress-bar">
        <ProgressBar
          :bottom-offset="bottomOffset"
          :force-hide-bottom-offset="forceHideBottomOffset"
        />
      </div>

      <div class="article-content">
        <PostContent :content="content.content" />

        <TabsComponent />
        <!-- problem is in ArticleContent-->
        <PostContent :content="content.graph" />
        <PostContent :content="content.methodology" />
      </div>
    </div>
    <TheFooter
      :is-hide-donation-form="false"
      :is-hide-subscription-block="false"
      :is-special="true"
    />
  </LayoutDefaultPage>
</template>

<style lang="postcss">
.special {
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
  }

  th,
  td {
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f5f5f5;
  }

  tr:hover {
    background-color: #ddd;
  }

  margin: 24px auto 80px auto;
  padding: 0;

  & .article-content {
    overflow: hidden;
    padding-bottom: 80px;

    & .post-content .embed {
      max-width: 1040px;
    }

    & .post-content p {
      max-width: var(--content-max-width);
      margin-right: auto;
      margin-left: auto;
      padding: var(--article-content-padding-medium-vp);

      @media (--medium-vp) {
        padding: var(--article-content-padding-medium-vp);
      }

      @media (--tablet-vp) {
        padding: var(--tablet-layout-padding);
      }

      @media (--small-vp) {
        padding: 0 12px;
      }
    }

    @media (--small-vp) {
      padding-bottom: 40px;
    }
  }

  &__button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 72px;

    @media (--small-vp) {
      margin-bottom: 36px;
    }
  }

  @media (--medium-vp) {
    padding: 0 30px;
  }

  @media (--small-vp) {
    padding: 0 12px;
  }

  &__header-card {
    position: relative;
    z-index: -1;
    margin-bottom: calc(var(--main-header-height) * -1);

    &::before {
      content: '';
      background: linear-gradient(180deg, transparent 0, rgb(57 61 130) 100%);
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      z-index: 2;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }
  }

  &__progress-bar {
    position: fixed;
    z-index: calc(var(--modal-z-index) - 1);
    top: auto;
    right: 50px;
    bottom: 50px;
    left: auto;

    &--mobile {
      position: relative;
      top: 4px;
    }
  }
}
</style>
